import { v4 as uuidv4 } from 'uuid';
import { KizViewInventorySvedPluginSettings } from './KizViewInventorySvedPluginSettings';
import { KizView } from './KizView';

export const KizViewInventorySvedTab = (): ITab => {
    return {
        id: uuidv4(),
        title: "КИЗ",
        view: {
            content: KizViewInventorySvedPluginSettings
                ? <KizView gridId={uuidv4()} plugin={KizViewInventorySvedPluginSettings} />
                : <p> Справочник не настроен </p>
        }
    }
}
